module.exports = __webpack_public_path__ + "static/media/mark-icon-2.8ee1fec9.svg";